import axios from "axios";

// Create axios instance with base configuration
const api = axios.create({
  baseURL:
    "https://njftprep2swcbforzroamhuvci0uhhim.lambda-url.us-east-1.on.aws/api",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
api.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      // Server responded with error status
      const { status, data } = error.response;
      console.error(`API Error ${status}:`, data.message || error.message);
    } else if (error.request) {
      // Request was made but no response received
      console.error("Network Error:", error.message);
    } else {
      // Something else happened
      console.error("Error:", error.message);
    }
    return Promise.reject(error);
  }
);

// Portfolio API methods
export const portfolioAPI = {
  // Get all portfolio data
  getAll: () => api.get("/portfolio"),

  // Get personal information
  getPersonal: () => api.get("/portfolio/personal"),

  // Get skills
  getSkills: () => api.get("/portfolio/skills"),

  // Get experience
  getExperience: () => api.get("/portfolio/experience"),

  // Get projects with optional filtering
  getProjects: (filters = {}) => {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        params.append(key, filters[key]);
      }
    });
    return api.get(
      `/portfolio/projects${params.toString() ? "?" + params.toString() : ""}`
    );
  },

  // Get single project
  getProject: id => api.get(`/portfolio/projects/${id}`),

  // Get testimonials
  getTestimonials: () => api.get("/portfolio/testimonials"),

  // Get education
  getEducation: () => api.get("/portfolio/education"),

  // Get certifications
  getCertifications: () => api.get("/portfolio/certifications"),

  // Get project categories
  getCategories: () => api.get("/portfolio/categories"),

  // Get technologies
  getTechnologies: () => api.get("/portfolio/technologies"),
};

// Contact API methods
export const contactAPI = {
  // Send contact form
  sendMessage: formData => api.post("/contact", formData),

  // Test email configuration
  testConfig: () => api.get("/contact/test-config"),
};

// Health check
export const healthAPI = {
  check: () => api.get("/health"),
};

export default api;
